import { TabList } from "@mui/lab";
import { List, ListItemButton, styled } from "@mui/material";

export const SelectCreateCard = styled("div")(
  ({
    gap = "1rem",
    padding = "1rem 1rem",
    minHeight,
    condition = true,
    justifyContent,
    cursor,
  }) => ({
    border: "1px solid #EAECF0",
    borderRadius: "10px",
    padding: padding,
    display: "flex",
    flexDirection: "column",
    gap: gap,
    boxShadow: " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    minHeight: minHeight,
    justifyContent: justifyContent || "space-between",
    ...(condition && {
      "&:hover": {
        transform: "scale(1.04)",
        cursor: cursor || "pointer",
        border: "1px solid #7F56D9",
        boxShadow: "1px 1px 10px 0px rgba(0, 0, 0, 0.12)",
      },
    }),
  })
);

export const HarizonTabViewSection = styled(TabList)(() => ({
  background: "#F9FAFB",
  border: "1px solid #EAECF0",
  borderRadius: "6px",
  gap: "5px",
  maxWidth: "fit-content",

  "& .MuiTabs-flexContainer": {
    width: "-webkit-fill-available",
  },
  "& .Mui-selected": {
    background: "#6941C6",
    margin: "5px",
    color: "#fff !important",
    boxShadow:
      "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);",
    borderRadius: "6px",
  },
  "& .MuiTab-root": {
    padding: "0px 2rem",
    minHeight: "37px",
    color: "#667085",
    fontWeight: 600,
    fontFamily: "Inter",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabScrollButton-horizontal": {
    background: "#ffff !important",
    margin: "7px 7px",
    borderRadius: "7px",
    boxShadow: "0px 0px 1px 0px #101828",
  },
}));

export const TableHead = styled("th")(
  ({ fontWeight = 700, textAlign = "left", width }) => ({
    fontWeight: fontWeight,
    textAlign: textAlign,
    padding: "4px",
    width: width,
  })
);

export const TableData = styled("td")(
  ({ fontWeight = 700, textAlign = "left" }) => ({
    fontWeight: fontWeight,
    textAlign: textAlign,
    padding: "4px",
  })
);

export const CustomListButton = styled(ListItemButton)(
  ({
    padding = 700,
    textAlign = "left",
    width,
    borderRadius,
    background,
    color,
  }) => ({
    padding: padding || "8px",
    borderRadius: borderRadius || "8px",
    width: width,
    color: color,
    background: background,
  })
);

export const CustomList = styled(List)(
  ({
    width,
    height,
    right,
    scrollStyle,
    displayBar,
    scrollBar,
    scrollBarRadius,
  }) => ({
    width: width,
    height: height,
    right: right,

    ...(scrollStyle && {
      overflow: "auto",
      "&::-webkit-scrollbar": {
        display: displayBar,
        width: scrollBar || "7px",
        height: scrollBar || "7px",
      },

      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: scrollBarRadius || "0px",
      },
    }),
  })
);
